import { cloneDeep } from "lodash-es";
import { useEffect, useRef } from "react";
import { switchNetwork } from "@wagmi/core";

import { GlobalStore } from "../store/global/GlobalStore";
import {
  processNetworkFromUrl,
  processTokensFromUrl,
  updateUrlParams,
  URL_KEYS,
} from "../utils/urlUtils";
import { useTokenListByChain } from "./useTokenListByChain";
import { UserRejectedRequestError } from "viem";
import { getChainIdFromName } from "utils/chainUtils";
import { useAccount } from "wagmi";

export function useUrlNetworkParams() {
  const params = new URL(window.location as unknown as string).searchParams;
  const network = params.get(URL_KEYS.NETWORK);
  const sellTokens = params.get(URL_KEYS.SELL);
  const buyTokens = params.get(URL_KEYS.BUY);
  const amounts = params.get(URL_KEYS.SELL_AMOUNT);
  const networkNameFromStore = GlobalStore.useState(s => s.network.name);
  const tokenList = useTokenListByChain();
  const currentNetwork = GlobalStore.useState(s => s.network);
  const hasProcessedUrl = useRef(false);
  const hasRequestedNetworkSwitch = useRef(false);

  const { connector: activeConnector, isConnected } = useAccount();

  useEffect(() => {
    if (hasRequestedNetworkSwitch.current) return;
    const networkMatch = processNetworkFromUrl(network);
    if (
      networkMatch &&
      switchNetwork &&
      networkMatch.name !== currentNetwork.name &&
      isConnected &&
      activeConnector
    ) {
      hasRequestedNetworkSwitch.current = true;
      try {
        void switchNetwork({
          chainId: getChainIdFromName(networkMatch.name),
        });
      } catch (error) {
        if (error instanceof UserRejectedRequestError) {
          // User rejected the network switch request, so we should clean the URL
          updateUrlParams(
            URL_KEYS.NETWORK,
            networkNameFromStore.toLowerCase(),
            window.location.pathname
          );
          updateUrlParams(URL_KEYS.SELL, "", window.location.pathname);
          updateUrlParams(URL_KEYS.BUY, "", window.location.pathname);
        }

        console.log("Error switching networks");
        console.log(error);
      }
    } else if (networkMatch && networkMatch.name !== currentNetwork.name) {
      GlobalStore.update(s => {
        s.network = cloneDeep(networkMatch) as typeof s.network;
      });
    }
  }, [
    currentNetwork,
    sellTokens,
    network,
    buyTokens,
    tokenList,
    isConnected,
    activeConnector,
    networkNameFromStore,
  ]);

  useEffect(() => {
    if (hasProcessedUrl.current) return;
    if (tokenList) {
      processTokensFromUrl(sellTokens, buyTokens, amounts, tokenList);
      hasProcessedUrl.current = true;
    }
  }, [buyTokens, networkNameFromStore, sellTokens, tokenList, amounts]);
}
